import React from 'react';

/* ── SVG icons ── */
const IconChecklist = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.0" strokeLinecap="round" strokeLinejoin="round" className="h-6 w-6">
    <path d="M9 11l3 3L22 4" /><path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11" />
  </svg>
);
const IconCalculator = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.0" strokeLinecap="round" strokeLinejoin="round" className="h-6 w-6">
    <rect x="4" y="2" width="16" height="20" rx="2" /><line x1="8" y1="6" x2="16" y2="6" /><line x1="8" y1="10" x2="16" y2="10" /><line x1="8" y1="14" x2="11" y2="14" /><line x1="8" y1="18" x2="11" y2="18" /><line x1="14" y1="14" x2="16" y2="14" /><line x1="14" y1="18" x2="16" y2="18" />
  </svg>
);
const IconCamera = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.0" strokeLinecap="round" strokeLinejoin="round" className="h-6 w-6">
    <path d="M23 19a2 2 0 01-2 2H3a2 2 0 01-2-2V8a2 2 0 012-2h4l2-3h6l2 3h4a2 2 0 012 2z" /><circle cx="12" cy="13" r="4" />
  </svg>
);
const IconReceipt = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.0" strokeLinecap="round" strokeLinejoin="round" className="h-6 w-6">
    <path d="M14 2H6a2 2 0 00-2 2v16l3-2 3 2 3-2 3 2 3-2V8z" /><line x1="16" y1="13" x2="8" y2="13" /><line x1="16" y1="17" x2="8" y2="17" /><polyline points="10 9 9 9 8 9" />
  </svg>
);
const IconWallet = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.0" strokeLinecap="round" strokeLinejoin="round" className="h-6 w-6">
    <path d="M20 7H4a2 2 0 00-2 2v10a2 2 0 002 2h16a2 2 0 002-2V9a2 2 0 00-2-2z" /><path d="M16 3H8L4 7h16z" /><circle cx="17" cy="14" r="1" />
  </svg>
);
const IconNewspaper = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.0" strokeLinecap="round" strokeLinejoin="round" className="h-6 w-6">
    <path d="M4 22h16a2 2 0 002-2V4a2 2 0 00-2-2H8a2 2 0 00-2 2v16a2 2 0 01-2 2zm0 0a2 2 0 01-2-2v-9c0-1.1.9-2 2-2h2" /><line x1="18" y1="14" x2="12" y2="14" /><line x1="18" y1="18" x2="12" y2="18" /><polyline points="12 6 12 10 18 10 18 6 12 6" />
  </svg>
);

const GOOGLE_PLAY = 'https://play.google.com/store/apps/details?id=com.geonukim.martcalculator&hl=ko';
const APP_STORE = 'https://apps.apple.com/kr/app/%EB%AA%A8%EB%91%90%EC%9D%98%EB%A7%88%ED%8A%B8-%EA%B0%80%EA%B2%A9%ED%91%9C%EC%8A%A4%EC%BA%90%EB%84%88/id6578441041';
const GOOGLE_BADGE = 'https://hebbkx1anhila5yf.public.blob.vercel-storage.com/%E1%84%80%E1%85%AE%E1%84%80%E1%85%B3%E1%86%AF%E1%84%91%E1%85%B3%E1%86%AF%E1%84%85%E1%85%A6%E1%84%8B%E1%85%B5-bGmkurHDcp4IBo6BHPM6XDb6KCmJSa.png';
const APPLE_BADGE = 'https://hebbkx1anhila5yf.public.blob.vercel-storage.com/%E1%84%8B%E1%85%A2%E1%86%B8%E1%84%89%E1%85%B3%E1%84%90%E1%85%A9%E1%84%8B%E1%85%A5-02-H4LNroXGZKHuLpd1QdTv3xqo2CyK62.png';

function StoreBadges() {
  return (
    <div className="flex flex-wrap items-center gap-4 mt-6">
      <a href={GOOGLE_PLAY} className="transition-transform hover:-translate-y-1 hover:scale-105 active:scale-95">
        <img src={GOOGLE_BADGE} alt="Google Play" className="h-[52px] w-auto drop-shadow-md" />
      </a>
      <a href={APP_STORE} className="transition-transform hover:-translate-y-1 hover:scale-105 active:scale-95">
        <img src={APPLE_BADGE} alt="App Store" className="h-[52px] w-auto drop-shadow-md" />
      </a>
    </div>
  );
}

export default function ModoMartLanding() {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col font-sans select-none overflow-x-hidden">
      
      {/* ── Navbar ── */}
      <header className="fixed top-0 z-50 transition-all duration-300 w-full flex justify-center py-4 px-4 sm:px-6">
        <div className="max-w-6xl w-full bg-white/80 backdrop-blur-xl border border-white rounded-[2rem] shadow-sm flex items-center justify-between px-6 py-3">
          <div className="flex items-center gap-3">
            <img src="/images/logo.png" alt="모두의마트" className="h-9 w-9 rounded-xl border border-gray-100 shadow-sm" />
            <span className="text-[17px] font-extrabold tracking-tight text-gray-900">
              모두의마트
            </span>
          </div>
          <a
            href="#download"
            className="rounded-full bg-brand-500 hover:bg-brand-600 px-5 py-2.5 text-[14px] font-bold text-white shadow-lg shadow-brand-500/30 transition-all hover:-translate-y-0.5"
          >
            무료 다운로드
          </a>
        </div>
      </header>

      {/* ── Hero Section (Blue Theme) ── */}
      <section className="relative px-5 pt-32 pb-20 lg:pt-40 lg:pb-32 lg:px-8 w-full max-w-7xl mx-auto flex flex-col-reverse lg:flex-row items-center gap-12 lg:gap-8">
        
        {/* Background glow effects */}
        <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-brand-200/40 rounded-full blur-[100px] -z-10 animate-pulse-slow" />
        <div className="absolute bottom-10 left-10 w-[400px] h-[400px] bg-indigo-100/40 rounded-full blur-[80px] -z-10" />

        {/* Text Content */}
        <div className="flex-1 text-center lg:text-left z-10 animate-fade-in-up">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-blue-50 border border-blue-100 shadow-sm mb-6">
            <span className="flex h-2.5 w-2.5 rounded-full bg-brand-500 animate-pulse"></span>
            <span className="text-sm font-bold text-brand-600">장보기 필수 앱 1위</span>
          </div>
          <h1 className="text-[46px] font-black leading-[1.2] tracking-tighter text-gray-900 sm:text-6xl lg:text-[72px]">
            계산은 쉽게, <br />
            <span className="text-brand-500">쇼핑은 즐겁게.</span>
          </h1>
          <p className="mt-6 text-lg tracking-tight sm:text-xl text-gray-500 max-w-2xl mx-auto lg:mx-0 leading-relaxed font-medium">
            체크리스트, 가격표 스캔, 예산 관리, 영수증 정리까지. <br className="hidden sm:block" />
            장보기의 모든 과정을 한 번에.
          </p>
        </div>

        {/* Hero Image Mockup from screenshots */}
        <div className="flex-1 w-full lg:max-w-none relative animate-float flex justify-center lg:justify-end">
          <div className="relative flex justify-center items-center w-full max-w-lg mt-10 lg:mt-0 gap-4 sm:gap-10">
            {/* 왼쪽 이미지 (스크린샷 2, 더 앞쪽에 위치) */}
            <img 
              src="/images/screenshot2.png" 
              alt="모두의마트 앱 화면 2" 
              className="relative z-20 w-[45%] sm:w-[45%] rounded-[1.5rem] sm:rounded-[2rem] shadow-2xl border-4 border-white rotate-3"
              onError={(e) => (e.currentTarget.style.display = 'none')}
            />
            {/* 오른쪽 이미지 (스크린샷 1, 살짝 아래로 처지고 뒤에 위치) */}
            <img 
              src="/images/screenshot1.png" 
              alt="모두의마트 앱 화면 1" 
              className="relative z-10 w-[45%] sm:w-[45%] rounded-[1.5rem] sm:rounded-[2rem] shadow-xl border-4 border-white -rotate-6 translate-y-12"
              onError={(e) => (e.currentTarget.style.display = 'none')}
            />
          </div>
        </div>
      </section>

      {/* ── Bento Grid Features ── */}
      <section className="bg-white py-24 rounded-t-[3rem] relative z-20 shadow-[0_-20px_40px_rgba(0,0,0,0.02)] border-t border-gray-100/50">
        <div className="mx-auto max-w-7xl px-5 lg:px-8">
          
          <div className="mb-16 text-center">
            <h2 className="text-3xl font-extrabold tracking-tight text-gray-900 sm:text-4xl text-glow">
              직관적이고 확실한 기능
            </h2>
            <p className="mt-4 text-lg text-gray-500 font-medium">
              모두의마트는 복잡함을 덜어내고, 쇼핑에 꼭 필요한 것만 남겼습니다.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
            
            {/* Bento 1. Checklist - Large Span */}
            <div className="group rounded-[2rem] bg-gray-50 p-8 border border-gray-100/80 transition-all hover:-translate-y-1 hover:shadow-xl hover:bg-white md:col-span-2 relative overflow-hidden">
              <div className="absolute -right-12 -top-12 w-64 h-64 bg-brand-50 rounded-full blur-[60px] opacity-0 group-hover:opacity-100 transition-opacity duration-700 pointer-events-none" />
              <div className="relative z-10 flex flex-col h-full justify-between gap-6">
                <div>
                  <div className="inline-flex h-12 w-12 items-center justify-center rounded-[1rem] bg-brand-100/50 text-brand-600 shadow-sm mb-6">
                    <IconChecklist />
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900">손쉬운 장보기 리스트</h3>
                  <p className="mt-3 text-[15px] leading-relaxed text-gray-500 max-w-md">
                    살 것을 미리 적어두고 하나씩 지워가세요. 진행률 바를 통해 얼마나 남았는지 직관적으로 확인할 수 있습니다.
                  </p>
                </div>
                {/* Clean HTML Mockup */}
                <div className="mt-6 flex justify-center sm:justify-end h-full items-end pb-2">
                  <div className="bg-white rounded-2xl p-5 shadow-[0_20px_50px_rgba(0,0,0,0.08)] border border-gray-100 w-full max-w-[260px] transform transition-transform hover:-translate-y-2">
                    <div className="flex justify-between items-center mb-4">
                      <span className="text-sm font-bold text-gray-800">장바구니 리스트</span>
                      <span className="text-xs font-semibold text-brand-500 bg-brand-50 px-2 py-1 rounded-full">2/5 완료</span>
                    </div>
                    <div className="space-y-3">
                      <div className="flex items-center gap-3 opacity-50">
                        <div className="h-5 w-5 bg-brand-500 rounded-lg flex items-center justify-center"><svg viewBox="0 0 12 12" className="h-3 w-3 text-white"><path d="M2 6l3 3 5-5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg></div>
                        <span className="text-[13px] font-medium line-through text-gray-400">무항생제 계란 30구</span>
                      </div>
                      <div className="flex items-center gap-3">
                        <div className="h-5 w-5 border-2 border-gray-300 rounded-lg"></div>
                        <span className="text-[13px] font-medium text-gray-800">서울우유 1L 2개</span>
                      </div>
                      <div className="flex items-center gap-3">
                        <div className="h-5 w-5 border-2 border-gray-300 rounded-lg"></div>
                        <span className="text-[13px] font-medium text-gray-800">국산 찌개용 두부</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Bento 2. Calculator */}
            <div className="group rounded-[2rem] bg-white p-8 border border-gray-100/80 shadow-[0_8px_30px_rgb(0,0,0,0.02)] transition-all hover:-translate-y-1 hover:shadow-xl flex flex-col justify-between">
              <div>
                <div className="inline-flex h-12 w-12 items-center justify-center rounded-[1rem] bg-indigo-50 text-indigo-500 shadow-sm mb-6">
                  <IconCalculator />
                </div>
                <h3 className="text-2xl font-bold text-gray-900">실시간 예산 관리</h3>
                <p className="mt-3 text-[15px] leading-relaxed text-gray-500">
                  물건을 담을 때마다 가격을 입력해 예산 초과를 방지하세요.
                </p>
              </div>
              <div className="mt-8 flex justify-center sm:justify-end h-full items-end">
                <div className="bg-gradient-to-tr from-gray-50 to-white rounded-2xl p-6 shadow-lg border border-gray-200/60 w-full max-w-[280px] transform transition-transform hover:-translate-y-2">
                  <div className="flex items-center justify-between mb-2">
                    <p className="text-xs font-bold text-gray-400 uppercase tracking-widest">현재 담은 금액</p>
                    <div className="w-2 h-2 rounded-full bg-green-400 animate-pulse"></div>
                  </div>
                  <p className="text-3xl font-black text-gray-900 tracking-tight">49,290<span className="text-lg font-bold ml-1 text-gray-500">원</span></p>
                  
                  <div className="mt-5 space-y-2">
                    <div className="flex justify-between text-[13px] font-semibold">
                      <span className="text-gray-500">목표 예산 (10만원)</span>
                      <span className="text-brand-600">50,710원 남음</span>
                    </div>
                    <div className="h-2.5 w-full bg-gray-100 rounded-full overflow-hidden">
                      <div className="h-full bg-brand-500 rounded-full w-[49%]"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Bento 3. Camera Scanner */}
            <div className="group rounded-[2rem] bg-gradient-to-br from-brand-600 to-brand-800 p-8 shadow-xl transition-all hover:-translate-y-1 hover:shadow-2xl hover:shadow-brand-900/20 text-white flex flex-col justify-between relative overflow-hidden">
              <div className="absolute -right-10 -bottom-10 w-48 h-48 bg-white opacity-10 rounded-full blur-2xl" />
              <div className="relative z-10">
                <div className="inline-flex h-12 w-12 items-center justify-center rounded-[1rem] bg-white/20 text-white backdrop-blur-md shadow-sm mb-6">
                  <IconCamera />
                </div>
                <h3 className="text-2xl font-bold">가격표 스캔</h3>
                <p className="mt-3 text-[15px] leading-relaxed text-blue-100">
                  가격표를 카메라로 찍어 편하게 등록하세요. AI가 가격을 즉시 인식합니다.
                </p>
              </div>
              <div className="relative z-10 mt-8 flex justify-center h-full items-end w-full">
                <div className="relative group/scanner cursor-pointer w-full max-w-[280px] rounded-2xl bg-white/10 backdrop-blur-md border border-white/20 p-5 shadow-2xl overflow-hidden hover:scale-105 transition-transform duration-300">
                  <div className="absolute inset-0 bg-brand-400/20 translate-y-[-100%] group-hover/scanner:translate-y-[100%] transition-transform duration-[1.5s] ease-in-out border-b-2 border-brand-300"></div>
                  <div className="flex flex-col items-center">
                    <div className="w-full border-t border-white/20 flex justify-center py-2 text-white/40 mb-2">
                       <span className="text-[10px] font-bold tracking-[0.2em]">가격표 인식 중...</span>
                    </div>
                    <p className="text-sm font-medium text-white/80 mb-1">인식된 상품 가격</p>
                    <p className="text-4xl font-black text-white tracking-tight">2,900<span className="text-xl ml-1 text-white/70">원</span></p>
                  </div>
                </div>
              </div>
            </div>

            {/* Bento 4. Receipt Scanner */}
            <div className="group rounded-[2rem] bg-white p-8 border border-gray-100/80 shadow-[0_8px_30px_rgb(0,0,0,0.02)] transition-all hover:-translate-y-1 hover:shadow-xl lg:col-span-2 flex flex-col sm:flex-row justify-between items-center overflow-hidden">
              <div className="sm:w-1/2">
                <div className="inline-flex h-12 w-12 items-center justify-center rounded-[1rem] bg-emerald-50 text-emerald-500 shadow-sm mb-6">
                  <IconReceipt />
                </div>
                <h3 className="text-2xl font-bold text-gray-900">영수증 자동 정리</h3>
                <p className="mt-3 text-[15px] leading-relaxed text-gray-500">
                  긴 영수증도 사진 1장이면 끝납니다. 텍스트를 추출해 가계부로 깔끔하게 변환해 드려요.
                </p>
              </div>
              <div className="mt-8 sm:mt-0 sm:w-1/2 flex justify-center sm:justify-end">
                <div className="bg-white rounded-t-[1.5rem] p-5 shadow-[0_-10px_40px_rgba(0,0,0,0.06)] border border-gray-100 min-w-[260px] border-b-0 border-dashed transform transition-transform hover:-translate-y-4">
                   <div className="text-center border-b border-gray-200 border-dashed pb-3 mb-3">
                     <p className="text-[11px] font-bold text-gray-400 tracking-widest">모두의마트 영수증</p>
                     <p className="text-sm font-semibold text-gray-800 mt-1">2026. 04. 06 (월)</p>
                   </div>
                   <div className="space-y-2">
                     <div className="flex justify-between items-center text-[13px] font-medium text-gray-600"><span>햇반 210g 8개입</span><span className="font-semibold text-gray-800">8,900</span></div>
                     <div className="flex justify-between items-center text-[13px] font-medium text-gray-600"><span>제주 삼다수 2L</span><span className="font-semibold text-gray-800">1,200</span></div>
                     <div className="flex justify-between items-center text-[13px] font-medium text-gray-600"><span>동원참치 150g</span><span className="font-semibold text-gray-800">2,500</span></div>
                     <div className="flex justify-between items-center text-sm font-bold text-gray-900 mt-2 pt-2 border-t border-gray-100"><span>총 합계</span><span className="text-brand-600">12,600원</span></div>
                   </div>
                </div>
              </div>
            </div>

            {/* Bento 5. Mart Flyers - Large Span */}
            <div className="group rounded-[2rem] bg-gradient-to-br from-blue-50 to-white p-8 border border-blue-100/50 transition-all hover:-translate-y-1 hover:shadow-xl md:col-span-2 lg:col-span-3 relative overflow-hidden">
              <div className="flex flex-col h-full lg:flex-row gap-8 items-center justify-between">
                <div className="lg:w-1/2">
                   <div className="inline-flex h-12 w-12 items-center justify-center rounded-[1rem] bg-white text-brand-600 shadow-sm mb-6 border border-brand-100">
                    <IconNewspaper />
                   </div>
                   <h3 className="text-2xl font-bold text-gray-900">마트 전단지도 한눈에</h3>
                   <p className="mt-3 text-[15px] leading-relaxed text-gray-600">
                     이마트, 홈플러스, 코스트코 등 대형마트의 주간 할인 전단지를 앱에서 바로바로 확인하세요. 합리적 소비의 지름길입니다.
                   </p>
                </div>
                <div className="w-full lg:w-1/2 flex flex-wrap gap-4 justify-center lg:justify-end">
                   {[
                     { name: '이마트 금주 할인', color: 'bg-yellow-50 text-yellow-700 border-yellow-200', tag: 'D-2' },
                     { name: '홈플러스 1+1 행사', color: 'bg-red-50 text-red-700 border-red-200', tag: 'NEW' },
                     { name: '코스트코 세일', color: 'bg-blue-50 text-blue-700 border-blue-200', tag: 'D-4' },
                     { name: '롯데마트 전단특가', color: 'bg-red-50 text-red-700 border-red-200', tag: '오늘마감' }
                   ].map((mart) => (
                     <div key={mart.name} className="flex items-center justify-between px-5 py-3.5 rounded-2xl border border-gray-200/80 shadow-sm w-full max-w-[240px] bg-white transform transition-transform hover:-translate-y-1 hover:shadow-md cursor-pointer">
                       <span className="text-[14px] font-bold text-gray-800">{mart.name}</span>
                       <span className={`text-[10px] font-bold px-2 py-0.5 rounded-full border ${mart.color}`}>
                         {mart.tag}
                       </span>
                     </div>
                   ))}
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* ── Call To Action ── */}
      <section id="download" className="bg-brand-600 py-24 relative overflow-hidden text-center">
        {/* Abstract glow */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-brand-400/40 rounded-full blur-[120px] pointer-events-none" />
        
        <div className="mx-auto max-w-4xl px-5 relative z-10">
          <h2 className="text-4xl lg:text-[50px] font-black text-white tracking-tight mb-6 leading-tight drop-shadow-sm">
            예산에 맞는 <br className="sm:hidden" /> 합리적인 소비, <br />
            <span className="text-brand-100">지금 바로 시작하세요.</span>
          </h2>
          <p className="text-lg text-brand-100/80 mb-10 max-w-xl mx-auto font-medium">
            iOS, Android 앱스토어에서 무료로 다운로드할 수 있습니다.
          </p>
          <div className="flex justify-center">
            <StoreBadges />
          </div>
        </div>
      </section>

      {/* ── Footer ── */}
      <footer className="bg-white px-5 py-16 lg:px-8 border-t border-gray-100">
        <div className="mx-auto max-w-7xl">
          <div className="grid gap-10 text-sm text-gray-500 sm:grid-cols-2 lg:grid-cols-4 lg:gap-8">
            <div className="space-y-4">
              <div className="flex items-center gap-2 mb-4">
                 <img src="/images/logo.png" alt="Logo" className="w-7 h-7 rounded-lg grayscale opacity-70" />
                 <span className="font-extrabold text-gray-900 tracking-tight text-lg">모두의마트</span>
              </div>
              <p className="leading-relaxed font-medium">상호명: 라이프라인<br/>대표자: 김건우<br/>개인정보보호책임자: 김건우</p>
            </div>
            <div className="space-y-4 lg:pt-10">
              <p className="text-xs font-bold uppercase tracking-widest text-gray-900">사업자 정보</p>
              <div className="space-y-2 font-medium">
                <p>사업자등록번호: 160-07-03064</p>
                <p>통신판매업신고: 제 2025-경기파주-3357호</p>
              </div>
            </div>
            <div className="space-y-4 lg:pt-10">
              <p className="text-xs font-bold uppercase tracking-widest text-gray-900">주소 · 연락처</p>
              <div className="space-y-2 font-medium">
                <p>경기도 파주시 교하로 100, 910동 104호</p>
                <p>010-6707-3619</p>
                <a href="mailto:er4t@naver.com" className="hover:text-brand-600 transition-colors">er4t@naver.com</a>
              </div>
            </div>
            <div className="space-y-4 lg:pt-10">
              <p className="text-xs font-bold uppercase tracking-widest text-gray-900">약관</p>
              <div className="space-y-2 flex flex-col items-start font-medium">
                <a href="/privacy.html" className="hover:text-gray-900 transition-colors">개인정보 처리방침</a>
                <a href="/terms.html" className="hover:text-gray-900 transition-colors">서비스 이용약관</a>
              </div>
            </div>
          </div>
          <div className="mt-16 border-t border-gray-100 pt-8 flex flex-col justify-between items-center gap-4 text-xs font-semibold text-gray-400">
            <p>© {new Date().getFullYear()} 라이프라인. All rights reserved.</p>
          </div>
        </div>
      </footer>

    </div>
  );
}
